import { IProps } from './types';

export const hasRouteChanged = (nextProps: IProps, currentProps: IProps) =>
  !nextProps || nextProps.location.pathname !== currentProps.location.pathname;

export const scrollToTop = () => window.scrollTo(0, 0);
